import {
  toWSDateString,
  WSTableCell,
  WSTableColumn
} from "@wingspanhq/fe-component-library";
import {
  AccountTransaction,
  AccountTransactionDirection,
  Currency
} from "@wingspanhq/wingspan-api-sdk";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";

export const getColumns = (): WSTableColumn<AccountTransaction>[] => [
  {
    config: {
      header: { text: "Description" },
      gridTemplateSizeMax: "1fr"
    },
    renderFunction: rowItem => (
      <WSTableCell
        text={rowItem.data.description}
        secondaryText={toWSDateString(rowItem.data.effectiveAt, "monthDayYear")}
      />
    )
  },
  {
    config: {
      header: { text: "Category" },
      gridTemplateSizeMax: "0.5fr",
      hideOnScreens: ["XS", "S"]
    },
    renderFunction: rowItem => (
      <WSTableCell text={rowItem.data.category || "—"} />
    )
  },
  {
    config: {
      header: { text: "Status" },
      gridTemplateSizeMax: "0.4fr",
      hideOnScreens: ["XS"]
    },
    renderFunction: rowItem => (
      <WSTableCell pill={{ text: rowItem.data.status }} />
    )
  },
  {
    config: {
      header: { text: "Amount" },
      gridTemplateSizeMax: "auto",
      justify: "end"
    },
    renderFunction: rowItem => (
      <WSTableCell
        text={formatMoney(
          Number(rowItem.data.amount) *
            (rowItem.data.direction === AccountTransactionDirection.DEBIT
              ? -1
              : 1),
          rowItem.data.currency ?? Currency.USD,
          { showSign: true }
        )}
      />
    )
  }
];
